import React from 'react';
import { AccordionContainer } from '../../../../../../common/components/accordion/accordion.module';
import { InputContainer } from '../../../../../../common/components/form/form.module';

export const BranchBasicInfoComponent = ({ branchTypes, onInnerFormChange, selectedBranch, organizationUnits }: any) => (
          <>
  <AccordionContainer
      child={
        <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
          <InputContainer
              label="Name"
              name="Name"
              onValueChange={(event: any) => {
                onInnerFormChange(
                  event.target.value,
                  'BranchInfo.Name',
                  selectedBranch?.BranchInfo
                )
              }}
              type="text"
              value={selectedBranch?.BranchInfo?.Name}
          />
       <InputContainer
              label="PhoneNumber"
              name="PhoneNumber"
              onValueChange={(event: any) => {
                onInnerFormChange(
                  event.target.value,
                  'BranchInfo.PhoneNumber',
                  selectedBranch?.BranchInfo
                )
              }}
              type="text"
              value={selectedBranch?.BranchInfo?.PhoneNumber}
          />
      <InputContainer
              label="Email"
              name="Email"
              onValueChange={(event: any) => {
                onInnerFormChange(
                  event.target.value,
                  'BranchInfo.Email',
                  selectedBranch?.BranchInfo
                )
              }}
              type="text"
              value={selectedBranch?.BranchInfo?.Email}
          />
    <InputContainer
            label="BranchType"
            labelField="Text"
            list={branchTypes}
            onValueChange={(event: any, newValue: any) => {
              onInnerFormChange(
                event.target.value,
                'BranchInfo.BranchTypeId',
                selectedBranch?.BranchInfo
              );
            }}
            optionName='Choose BranchType'
            type="select"
            value={selectedBranch?.BranchInfo?.BranchTypeId}
            valueField="Value"
        />
     <InputContainer
            label="OrganizationUnit"
            labelField="OrganizationUnitInfo.Name"
            list={organizationUnits}
            onValueChange={(event: any, newValue: any) => {
              onInnerFormChange(
                event.target.value,
                'BranchInfo.OrganizationUnitId',
                selectedBranch?.BranchInfo
              );
            }}
            optionName='Choose OrganizationUnit'
            type="select"
            value={selectedBranch?.BranchInfo?.OrganizationUnitId}
            valueField="OrganizationUnitInfo.Id"
        />
    <InputContainer

              label="PrimaryBranch"
              name="IsPrimaryBranch"
              onValueChange={(event: any) => {
                onInnerFormChange(
                  event,
                  'BranchInfo.IsPrimaryBranch',
                  selectedBranch?.BranchInfo
                )
              }}
              type="checkbox"
              value={selectedBranch?.BranchInfo?.IsPrimaryBranch}
          />
    </div>
 }
 expandedPanel="basicInfo"
 headerTitle="Basic Info"
/>
</>
)
export default BranchBasicInfoComponent;
